import { Table } from "reactstrap";
import InvoiceTableBody from "./InvoiceTableBody";

// This component displays the invoice table head with the product description, quantity, unit price, and subtotal amounts.
const InvoiceTableHead = () => {
  return (
    <Table borderless className="table-wrapper" >
      <thead>
        <tr >
          <th>
            <span >No.</span>
          </th>
          <th> 
            <span >Description</span>
          </th>
          <th>
            <span >Unit Price</span>
          </th> 
          <th>
            <span >Quantity</span> 
          </th>
          <th>
            <span >Subtotal</span>
          </th>
        </tr>
      </thead>
      <InvoiceTableBody />
    </Table>
  );
};

export default InvoiceTableHead;
